/** COPY_OPEN：复制支付链接后在支付应用内打开 */

export const COPY_OPEN_PRESENTATION = 'COPY_OPEN_IN_ALIPAY'
export const PAYER_NAME_THEN_PAY_PRESENTATION = 'PAYER_NAME_THEN_PAY'

export function isCopyOpenPresentation (presentation) {
  return String(presentation || '').trim().toUpperCase() === COPY_OPEN_PRESENTATION
}

export function isPayerNameThenPayPresentation (presentation) {
  return String(presentation || '').trim().toUpperCase() === PAYER_NAME_THEN_PAY_PRESENTATION
}

export function resolveCopyOpenUrl (payload) {
  if (!payload) {
    return ''
  }
  const url = payload.copyOpenPayUrl || payload.payUrl || payload.codeUrl || ''
  return String(url).trim()
}

export function copyTextToClipboard (text) {
  const value = String(text || '').trim()
  if (!value) {
    return Promise.reject(new Error('暂无可复制内容'))
  }
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(value)
  }
  return new Promise((resolve, reject) => {
    try {
      const ta = document.createElement('textarea')
      ta.value = value
      ta.setAttribute('readonly', 'readonly')
      ta.style.position = 'fixed'
      ta.style.left = '-9999px'
      document.body.appendChild(ta)
      ta.select()
      const ok = document.execCommand('copy')
      document.body.removeChild(ta)
      if (ok) {
        resolve()
      } else {
        reject(new Error('复制失败，请长按链接手动复制'))
      }
    } catch (e) {
      reject(e)
    }
  })
}

export const DEFAULT_COPY_OPEN_HINT =
  '请点击「复制支付链接」，在聊天窗或浏览器地址栏粘贴打开；若提示即将离开，请点击「继续访问」。'
